import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const AlarmIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M8.87863 3C8.87863 2.44772 9.32634 2 9.87863 2H14.1213C14.6736 2 15.1213 2.44772 15.1213 3C15.1213 3.55228 14.6736 4 14.1213 4H12.9999V5.05275C17.4314 5.52277 20.9549 9.07884 20.9549 13.5C20.9549 18.2491 16.8893 22 11.9999 22C7.11056 22 3.045 18.2491 3.045 13.5C3.045 9.07884 6.56849 5.52277 10.9999 5.05275V4H9.87863C9.32634 4 8.87863 3.55228 8.87863 3ZM5.97761 4.32867C6.35647 4.73052 6.33784 5.36341 5.936 5.74227L3.686 7.86359C3.28415 8.24246 2.65126 8.22383 2.2724 7.82198C1.89353 7.42013 1.91216 6.78724 2.31401 6.40838L4.56401 4.28706C4.96585 3.9082 5.59875 3.92683 5.97761 4.32867ZM18.0224 4.32878C18.4013 3.92693 19.0341 3.9083 19.436 4.28716L21.686 6.40848C22.0878 6.78735 22.1065 7.42024 21.7276 7.82208C21.3487 8.22393 20.7159 8.24256 20.314 7.8637L18.064 5.74238C17.6622 5.36351 17.6435 4.73062 18.0224 4.32878ZM11.9999 7C8.10253 7 5.045 9.96482 5.045 13.5C5.045 17.0352 8.10253 20 11.9999 20C15.8974 20 18.9549 17.0352 18.9549 13.5C18.9549 9.96482 15.8974 7 11.9999 7ZM11.9999 9C12.5522 9 12.9999 9.44772 12.9999 10V12.9824L14.6986 14.1835C15.1496 14.5024 15.2566 15.1264 14.9378 15.5774C14.6189 16.0283 13.9949 16.1354 13.5439 15.8165L11.4226 14.3165C11.1575 14.1291 10.9999 13.8246 10.9999 13.5V10C10.9999 9.44772 11.4477 9 11.9999 9Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

AlarmIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(AlarmIcon);
